import { render, staticRenderFns } from "./DocumentDashboard.vue?vue&type=template&id=1ffc04b0"
import script from "./DocumentDashboard.vue?vue&type=script&lang=js"
export * from "./DocumentDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports